import React from 'react';
import { CrewMember } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import style from './crewMembersDetails.module.scss';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';
import { LabeledItem } from '../common/labeledItem';

interface CrewMembersDetailsContentProps {
    crewMembers: CrewMember[];
}

const MobileCrewMembersDetails: React.SFC<CrewMembersDetailsContentProps> = ({crewMembers}) => {
    return (
        <div className={style.MobileCrewMembers}>
            {crewMembers.map((crewMember, index) => (
                <div key={index} className={style.ItemContainerBordered}>
                    <LabeledItem
                        label={
                            <FormattedMessage
                                id={'components.itinerary.crewMembers.role'}
                                defaultMessage={'Role'}
                            />}
                    >
                        {crewMember.roleName}
                    </LabeledItem>
                    <LabeledItem
                        label={
                            <FormattedMessage
                                id={'components.itinerary.crewMembers.name'}
                                defaultMessage={'Name'}
                            />}
                    >
                        {crewMember.fullName}
                    </LabeledItem>
                    <LabeledItem
                        label={
                            <FormattedMessage
                                id={'components.itinerary.crewMembers.mobile'}
                                defaultMessage={'Mobile'}
                            />}
                    >
                        {crewMember.telephone}
                    </LabeledItem>
                </div>
            ))}
        </div>
    );
};

const LargeCrewMembersDetails: React.SFC<CrewMembersDetailsContentProps> = ({crewMembers}) => {
    return (
        <table className={style.CrewMembersTable}>
            <thead>
                    <tr>
                        <th>
                            <FormattedMessage
                                id={'components.itinerary.crewMembers.role'}
                                defaultMessage={'Role'}
                            />
                        </th>
                        <th>
                            <FormattedMessage
                                id={'components.itinerary.crewMembers.name'}
                                defaultMessage={'Name'}
                            />
                        </th>
                        <th>
                            <FormattedMessage
                                id={'components.itinerary.crewMembers.mobile'}
                                defaultMessage={'Mobile'}
                            />
                        </th>
                    </tr>
            </thead>
            <tbody>
                {crewMembers.map((crewMember, index) => (
                    <tr key={index}>
                        <td>{crewMember.roleName}</td>
                        <td>{crewMember.fullName}</td>
                        <td>{crewMember.telephone}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

const CrewMembersDetailsContent: React.SFC<CrewMembersDetailsContentProps> =
    ({crewMembers}) => {
        if (crewMembers.length === 0) {
            return null;
        }
        return (
            <div className={style.Container}>
                    <MobileCrewMembersDetails crewMembers={crewMembers} />
                    <LargeCrewMembersDetails crewMembers={crewMembers} />
            </div>
        );
};

const CrewMembersDetails = withCollapsable(
    (
        <Title>
            <FormattedMessage
                id={'components.itinerary.crewMembersTitle'}
                defaultMessage={'CREW DETAILS'}
            />
        </Title>
    ),
    CrewMembersDetailsContent);
export { CrewMembersDetails };
